module.exports = __webpack_public_path__ + "static/media/17159042_10210410989805948_5107849974417474840_o.db015a98.jpg";